import { createIcon } from '@chakra-ui/icons';

export const BookmarkFilled = createIcon({
  displayName: 'BookmarkFilled',
  viewBox: '0 0 18 18',
  path: [
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 14.6958C15 15.4812 14.136 15.96 13.47 15.5438L9.53 13.0812C9.20573 12.8786 8.79427 12.8786 8.47 13.0812L4.53 15.5438C3.86395 15.96 3 15.4812 3 14.6958V3C3 2.17125 3.67125 1.5 4.5 1.5H13.5C14.3287 1.5 15 2.17125 15 3V14.6958Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
